import React from 'react'

import Header from './Header/Header'
import Hero from './Hero/Hero'
import Credibility from './Credibility/Credibility'
import Products from './Products/Products'
import Why from './Why/Why'
import Behind from './Behind/Behind'
import ContactUs from './ContactUs/ContactUs'
import Footer from './Footer/Footer'
import { Page } from './HomepageStyledComponents'

const Homepage = () => (
  <Page>
    <Header />
    <Hero />
    <Credibility />
    <Products />
    <Why />
    <Behind />
    <ContactUs />
    <Footer />
  </Page>
)

Homepage.displayName = 'Homepage'

export default Homepage
